import { useEffect, useState } from "react";
import { Category, Products } from "../../home";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Dnd from "../../../components/admin/Dnd";

const AdminProduct = () => {
  const [categoryId, setCategoryId] = useState(1);
  const [category, setCategory] = useState<Category[] | null>(null);

  // const [page, setPage] = useState<number>(1);
  const [total, setTotal] = useState<number>(0);

  const [product, setProduct] = useState<Products[] | null>(null);

  const navigate = useNavigate();

  useEffect(() => {
    total < 1 &&
      axios.get(`/api/product/count`).then((res) => setTotal(res.data.data));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    axios
      .get(`/api/category`)
      .then((res) => {
        if (res.data.code === "0000") {
          setCategory(res.data.data);
        }
      })
      .catch((e) => console.error(e));
  }, []);

  useEffect(() => {
    console.log(categoryId);
    axios
      .get(`/api/product?categoryId=${categoryId}`)
      .then((res) => {
        if (res.data.code === "0000") {
          console.log(res.data.data);
          setProduct(res.data.data);
        }
      })
      .catch((e) => console.error(e));
  }, [categoryId]);

  return (
    <div className=" relative w-full h-full">
      <div className="relative w-full h-full flex justify-between items-center">
        <h4>제품 목록</h4>
        <button
          className=" relative w-fit h-fit bg-primary text-white rounded-md px-5 py-0.5"
          onClick={() => navigate("/admin/product/new")}
        >
          추가하기
        </button>
      </div>
      {category && (
        <div
          className={`relative w-full h-full grid grid-cols-4 text-center mt-10 pb-5`}
        >
          {category.map((v, i) => (
            <div
              key={i}
              onClick={() => setCategoryId(v.id)}
              className={
                v.id === categoryId
                  ? "relative w-full h-full border border-primary bg-primary text-white py-1.5 cursor-pointer"
                  : "relative w-full h-full border bg-transparent text-primary py-1.5 cursor-pointer"
              }
            >
              <p className="hidden lg:block font-light">{v.name}</p>
              <small className="block lg:hidden font-light">{v.name}</small>
            </div>
          ))}
        </div>
      )}
      {product && <Dnd product={product} />}
    </div>
  );
};

export default AdminProduct;
